


















import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import Translation from '@/mixins/Translation'
import IssuedInvoiceList from '@/pages/issued-invoices/components/IssuedInvoiceList.vue'
import {Component, Mixins, Prop} from 'vue-property-decorator'

/**
 * @displayName IssuedInvoicesPage
 */
@Component({
  components: {
    MainLayout,
    HeaderLayout,
    FooterLayout,
    FooterButton,
    IssuedInvoiceList,
  },
})
export default class IssuedInvoicesPage extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number

  onClickIssue() {
    this.$router.push({name: 'issue'}).catch((e) => e)
  }
}
